// @flow
import * as React from "react";
import { withRouter } from "react-router-dom";
import Header, { type Links } from "../shared/Header";

import ScrollProvider from "../shared/ScrollProvider";
import Logo from "../../../assets/logos/DBB_Logo.svg";

import styles from "./PortalNavbar.scss";

type PortalNavbarProps = {
  links: Links,
  history: {
    location: { pathname: string },
    push: (path: string) => void,
    goBack: () => void
  },
  isLoggedIn: boolean,
  logoLink: string,
  logOutLink?: string
};

const PortalNavbar = ({ links, isLoggedIn, logoLink, logOutLink }: PortalNavbarProps) => (
  <ScrollProvider>
    {({ isScrolledToTop }) => (
      <React.Fragment>
        <div className={styles.navContainer}>
          <Header
            logos={[{ path: Logo, link: logoLink }]}
            areLinksVisible={isLoggedIn}
            links={links}
            isScrolledToTop={isScrolledToTop}
            logOutLink={logOutLink}
            type="portal"
          />
        </div>
      </React.Fragment>
    )}
  </ScrollProvider>
);

PortalNavbar.defaultProps = {
  areTabsVisible: true,
  isLoggedIn: true,
  backPath: "/"
};

export default withRouter(PortalNavbar);
